import { ICoverageDetails } from 'app/models/UserCoverage/UserCoverage';

type CoverageWithWindow = Pick<ICoverageDetails, 'startDate' | 'endDate'>;

/**
 * True when `now` falls within [startDate, endDate], inclusive (ISO strings parsed as Date).
 * Rows without both dates are excluded — API may return historical approved records without a reliable window.
 */
export function isCoverageEffectiveNow(coverage: CoverageWithWindow, now: Date = new Date()): boolean {
  const { startDate, endDate } = coverage;
  if (startDate == null || endDate == null || startDate === '' || endDate === '') {
    return false;
  }
  const startMs = Date.parse(String(startDate));
  const endMs = Date.parse(String(endDate));
  const t = now.getTime();
  if (Number.isNaN(startMs) || Number.isNaN(endMs)) {
    return false;
  }
  return t >= startMs && t <= endMs;
}

export function filterCurrentlyActiveCoverage<T extends CoverageWithWindow>(
  list: T[] | undefined | null,
  now?: Date,
): T[] {
  const at = now ?? new Date();
  return (list ?? []).filter(c => isCoverageEffectiveNow(c, at));
}
